export default __webpack_public_path__ + "static/aven 1-261277d92af8ea6a678413030665dfe7.png";